import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

const HasCallRequestRoute = ({ children, hasCallRequestToken }) => {
    const location = useLocation();
    
    if (hasCallRequestToken === true) {
        return children;
    } else {
        return (
            <Navigate
                to={{
                    pathname: '/create-call-request',
                    state: { from: location },
                }}
                replace
            />
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return { hasCallRequestToken: !!state.callRequest.callRequest };
};

export default connect(mapStateToProps, null)(HasCallRequestRoute);
